/**
 * Extract a human-readable message from a rejected secureAxios call.
 *
 * Two traps this exists to close:
 *
 * 1. `secureAxios` rejects with `error.response.data` (see its response
 *    interceptor), NOT the axios error. So inside `catch (err)` there is no
 *    `err.response` — anything reading `err?.response?.data?.…` is dead code
 *    that silently falls through to the fallback string every single time.
 * 2. uro-api returns `error` as an OBJECT (`{ message, code }`), so the
 *    otherwise-obvious `err?.error` renders as "[object Object]".
 *
 * @param {*} err       whatever secureAxios rejected with
 * @param {string} fallback shown when the server sent nothing usable
 * @returns {string}
 */
export const apiErrorText = (err, fallback) =>
  err?.error?.message || err?.error?.error || err?.message || fallback;

export default apiErrorText;
